import { fetchAuthSession } from "aws-amplify/auth";
import axios from "axios";

import constants from "../../constants";
import { fetchLocalAuthToken } from "../auth";

export const configureAxiosInterceptors = () => {
  axios.interceptors.request.use(
    async config => {
      // the token goes only to Keepo's API: never to the bucket (signed uploads), static hosts or anyone else
      if (constants.api && config?.url?.startsWith(constants.api)) {
        if (config?.headers) {
          const localAccessToken = fetchLocalAuthToken();
          if (localAccessToken) {
            config.headers["Authorization"] = "Bearer " + localAccessToken;
          } else {
            const { tokens } = await fetchAuthSession();
            if (tokens?.accessToken) {
              config.headers["Authorization"] = "Bearer " + tokens?.accessToken?.toString();
            }
          }
        }
      }
      return config;
    },
    e => Promise.reject(e)
  );
};
